import { useEffect, useState } from "react";
import "../../../styles/panel/user/Transactions.css";
import { fetchMyTransactions } from "../../../api/userFinance";
import { convertToPersianDigits, formatToman } from "../../../utils/stringUtil";
import moment from "jalali-moment";

function formatSuccess(success) {
  return success ? "موفق" : "ناموفق";
}
function formatOperation(op) {
  if (op === "deposit") return "واریز";
  if (op === "withdraw") return "برداشت";
  return op;
}

export default function Transactions() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetchMyTransactions()
      .then((res) => {
        setItems(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <div className="tx-page">
      <div className="tx-header">
        <h1>تراکنش‌ها</h1>
        <p>لیست کامل تراکنش‌های مالی حساب شما</p>
      </div>

      <div className="tx-card">
        {items.length === 0 ? (
          <div className="tx-empty">هیچ تراکنشی ثبت نشده است.</div>
        ) : (
          <div className="tx-table-wrap">
            <table className="tx-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>تاریخ</th>
                  <th>نوع عملیات</th>
                  <th>مبلغ (تومان)</th>
                  <th>وضعیت</th>
                  <th>فروشگاه</th>
                  <th>پلن</th>
                  <th>شماره فاکتور</th>
                </tr>
              </thead>
              <tbody>
                {items.map((t, i) => (
                  <tr key={t.id}>
                    <td className="tx-index">
                      {convertToPersianDigits(i + 1)}
                    </td>
                    <td className="tx-date">
                      {convertToPersianDigits(
                        moment(t.created_at).format("HH:mm , jYYYY/jMM/jDD"),
                      )}
                    </td>
                    <td>{formatOperation(t.operation_type)}</td>
                    <td className="tx-amount">
                      {formatToman(Number(t.amount))}
                    </td>
                    <td>
                      <span
                        className={`tx-badge tx-badge--${t.success ? "success" : "failed"}`}
                      >
                        {formatSuccess(t.success)}
                      </span>
                    </td>
                    <td>{t.store_name}</td>
                    <td>{t.plan_name}</td>
                    <td className="tx-invoice">{t.invoice_number}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
